import { useMutation, type MutationHookOptions } from "@apollo/client"
import mutation from "@/v2-backoffice-client/tenant/user/restore/many/tenant.user.restore.many.mutation.gql"
import type {
  TenantUserRestoreManyMutation,
  TenantUserRestoreManyMutationVariables,
} from "@/v2-backoffice-client/tenant/user/restore/many/__types__/tenant.user.restore.many.mutation"

type Options = MutationHookOptions<
  TenantUserRestoreManyMutation,
  TenantUserRestoreManyMutationVariables
>

export function useTenantUserRestoreManyMutation(options?: Options) {
  return useMutation<
    TenantUserRestoreManyMutation,
    TenantUserRestoreManyMutationVariables
  >(mutation, options)
}
